import { render, staticRenderFns } from "./manageStockTable.vue?vue&type=template&id=37354cfe&"
import script from "./manageStockTable.vue?vue&type=script&lang=js&"
export * from "./manageStockTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports